import store from '../store/store';
import axios from 'axios';
import { TokenService } from '../services/storage.service';

/*
Make a base service which will do all the interaction with the network so we can easily
change or upgrade stuff in the future. This is exactly what we’re trying to achieve
with the api.service.js— encapsulate the Axios library so that when inevitably a new
thing comes along we can return to this single service and upgrade it without having to
refactor the whole application. Any other service that needs to interact with API will
simply import the ApiService and issue requests via the helper methods we’ve implemented.

Метод init необходимо использовать в main.js.
*/

const ApiService = {
    /// Stores the 401 interceptor position so that it can be later ejected when needed
    _401interceptor: null,

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
        axios.defaults.withCredentials = true;
    },

    setHeader() {
        axios.defaults.headers.common['Authorization'] = `Bearer ${TokenService.getToken()}`;
    },

    removeHeader() {
        axios.defaults.headers.common = {};
    },

    get(resource, options) {
        if (options) {
            return axios.get(resource, options);
        }
        return axios.get(resource);
    },

    post(resource, data, options) {
        if (options) {
            return axios.post(resource, data, options);
        } else {
            return axios.post(resource, data);
        }
    },

    put(resource, data) {
        return axios.put(resource, data);
    },

    delete(resource) {
        return axios.delete(resource);
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return axios(data);
    },

    mount401Interceptor() {
        this._401interceptor = axios.interceptors.response.use(
            response => {
                return response;
            },
            async error => {
                if (error.request.status == 401) {
                    if (error.config.url.includes('/v1/login')) {
                        // Refresh token has failed. Logout the user
                        store.dispatch('auth/logout');
                        throw error;
                    } else {
                        // Refresh the access token
                        try {
                            await store.dispatch('auth/refreshToken');
                            // Retry the original request
                            return this.customRequest({
                                method: error.config.method,
                                url: error.config.url,
                                data: error.config.data
                            });
                        } catch (e) {
                            // Refresh has failed - reject the original request
                            throw error;
                        }
                    }
                }

                // If error was not 401 just reject as is
                throw error;
            }
        );
    },

    unmount401Interceptor() {
        // Eject the interceptor
        axios.interceptors.response.eject(this._401interceptor);
    }
};

export { ApiService };
